export default {
    // ----------Title----------
    parcels: 'Parcels',
    newParcel: 'New Parcel',
    ownership: 'Ownership',
    provideDetailsOfTheProfile: 'Provide details of the profile',
    parcelDetails: 'Parcel Details',
    provideTheInfoOfTheParcel: 'Provide the info of the parcel',
    measurement: 'Measurement',
    provideDetailItemMeasurement: 'Provide detail item measurement',
    theItemReceiveAndDeliveryOrderWillCreateAutomatically: 'The Item Receive and Delivery Order will create automatically.',

    // -----------MUI----------
    productCode: 'Product Code',
    quantity: 'Quantity',
    uom: 'Uom',
    pricePerUnit: 'Price Per Unit',
    volumeWeight: 'Volume Weight',
    grossWeight: 'Gross Weight',
    netWeight: 'Net Weight',
}